<template>
    <kt-panel>
        <kt-heading class="px-3" level="1">
            {{ $t('label.bank_management') }}
        </kt-heading>
        <div class="mx-2 my-4">
            <table class="table table-head-solid table-bordered">
                <thead>
                <tr>
                    <th class="text-center">{{ $t('label.bank') }}</th>
                    <th class="text-center" style="width: 400px;">{{ $t('label.actual_account_bank_balance') }}</th>
                    <th class="text-center">{{ $t('label.expected_account_bank_balance') }}</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(value, name, index) in bank_status" :key="index">
                    <template v-if="name !== 'sina'">
                        <td class="text-center">{{ $t(`wallets.bank.${name}`) }}</td>
                        <td>
                            <div>
                                <table v-if="name !== 'sina' && allBalances[name]"
                                       class="table table-head-solid table-bordered">
                                    <thead>
                                    <tr>
                                        <th class="text-center">{{ $t('label.account.number') }}</th>
                                        <th class="text-center">{{ $t('label.account.balance') }}</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr v-for="(balance, key) in allBalances[name].balances" :key="key">
                                        <td>{{ balance.account_number }}</td>
                                        <td>{{ balance.actual_balance }}</td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                        </td>
                        <td v-text="value.expected_balance"></td>
                    </template>
                </tr>
                </tbody>
                <tfoot>
                <tr>
                    <td v-text="$t('label.total')"></td>
                    <td v-text="moneyFormat(total_actual_balance.toString())"></td>
                    <td v-text="total_expected_balance"></td>
                    <td :class="expected_balance_is_higher_than_actual ? 'text-white bg-danger' : 'text-white bg-success'">
                        <span class="px-1" v-text="$t('label.balance_conflict')"></span>&nbsp;
                        <span
                            v-text="moneyFormat(Math.abs(actual_balance_and_expected_balance_diff).toString())"></span>
                    </td>
                </tr>
                </tfoot>
            </table>
        </div>
    </kt-panel>
</template>

<script>
import {walletService} from "@/common/api.service";
import {bankId, bankIdStr} from "@/constants/bankId";
import {sumBy} from "lodash/math";

export default {
    props: {
        fetch_starshop: {
            default: false,
            type: Boolean
        },
    },
    name: "balances",
    computed: {
        bankIdStr() {
            return bankIdStr;
        },
    },
    data() {
        return {
            bank_data: [],
            bank_status: [],
            isActive: false,
            total_actual_balance: 0,
            total_expected_balance: '',
            actual_balance_and_expected_balance_diff: '',
            expected_balance_is_higher_than_actual: false,

            ayandeBalances: [],
            saderatBalances: [],
            samanBalances: [],
            keshavarziBalances: [],
            parsianBalances: [],
            pasargadBalances: [],
            tejaratBalances: [],
            melliBalances: [],
            mellatBalances: [],
            allBalances: [],
        };
    },
    methods: {
        moneyFormat(price) {
            price = this.formatLess(price);
            const pieces = parseFloat(price).toFixed(0).split('');
            let len = pieces.length;

            while ((len -= 3) > 0) {
                pieces.splice(len, 0, ',');
            }

            return pieces.join('');
        },
        checkSettlementToken() {
            let params = {
                wallet_prefix: 'A',
            };

            const bankStatus = this.fetch_starshop
                ? walletService.getStarShopBankStatus
                : walletService.getBankStatus;

            bankStatus(params).then(res => {
                this.bank_status = res.data.data.bank_data;
            });

            const settlementToken = this.fetch_starshop
                ? walletService.checkStarShopSettlementToken
                : walletService.checkSettlementToken;

            settlementToken(params).then(res => {
                this.bank_data = res.data.data.bank_data;
                Object.keys(this.bank_data).forEach(item => {
                    this.bank_status[item]['expected_balance'] = this.bank_data[item]['expected_balance'];
                });
                this.total_expected_balance = res.data.data.total_expected_balance;
            });

            this.$forceUpdate();
        },
        getAllBalances() {
            let params = {
                wallet_prefix: 'A',
            };

            const actualBalanceBanks = this.fetch_starshop
                ? walletService.getStarShopActualBalanceByBankId
                : walletService.getActualBalanceByBankId;

            actualBalanceBanks(params, bankId.ayande).then(res => {
                this.ayandeBalances = res.data.data;
                this.allBalances['ayande'] = this.ayandeBalances;

                const totalBalance = sumBy(this.ayandeBalances.balances, balance => {
                    return this.parseFloatFromCurrency(balance.actual_balance);
                });

                this.total_actual_balance += totalBalance;
            });

            actualBalanceBanks(params, bankId.saderat).then(res => {
                this.saderatBalances = res.data.data;
                this.allBalances['saderat'] = this.saderatBalances;

                const totalBalance = sumBy(this.saderatBalances.balances, balance => {
                    return this.parseFloatFromCurrency(balance.actual_balance);
                });

                this.total_actual_balance += totalBalance;
            });

            actualBalanceBanks(params, bankId.saman).then(res => {
                this.samanBalances = res.data.data;
                this.allBalances['saman'] = this.samanBalances;

                const totalBalance = sumBy(this.samanBalances.balances, balance => {
                    return this.parseFloatFromCurrency(balance.actual_balance);
                });

                this.total_actual_balance += totalBalance;
            });

            actualBalanceBanks(params, bankId.keshavarzi).then(res => {
                this.keshavarziBalances = res.data.data;
                this.allBalances['keshavarzi'] = this.keshavarziBalances;

                const totalBalance = sumBy(this.keshavarziBalances.balances, balance => {
                    return this.parseFloatFromCurrency(balance.actual_balance);
                });

                this.total_actual_balance += totalBalance;
            });

            actualBalanceBanks(params, bankId.parsian).then(res => {
                this.parsianBalances = res.data.data;
                this.allBalances['parsian'] = this.parsianBalances;

                const totalBalance = sumBy(this.parsianBalances.balances, balance => {
                    return this.parseFloatFromCurrency(balance.actual_balance);
                });

                this.total_actual_balance += totalBalance;
            });

            actualBalanceBanks(params, bankId.pasargad).then(res => {
                this.pasargadBalances = res.data.data;
                this.allBalances['pasargad'] = this.pasargadBalances;

                const totalBalance = sumBy(this.pasargadBalances.balances, balance => {
                    return this.parseFloatFromCurrency(balance.actual_balance);
                });

                this.total_actual_balance += totalBalance;
            });

            actualBalanceBanks(params, bankId.tejarat).then(res => {
                this.tejaratBalances = res.data.data;
                this.allBalances['tejarat'] = this.tejaratBalances;

                const totalBalance = sumBy(this.tejaratBalances.balances, balance => {
                    return this.parseFloatFromCurrency(balance.actual_balance);
                });

                this.total_actual_balance += totalBalance;
            });

            actualBalanceBanks(params, bankId.melli).then(res => {
                this.melliBalances = res.data.data;
                this.allBalances['melli'] = this.melliBalances;

                const totalBalance = sumBy(this.melliBalances.balances, balance => {
                    return this.parseFloatFromCurrency(balance.actual_balance);
                });

                this.total_actual_balance += totalBalance;
            });

            actualBalanceBanks(params, bankId.mellat).then(res => {
                this.mellatBalances = res.data.data;
                this.allBalances['mellat'] = this.mellatBalances;

                const totalBalance = sumBy(this.mellatBalances.balances, balance => {
                    return this.parseFloatFromCurrency(balance.actual_balance);
                });

                this.total_actual_balance += totalBalance;
            });
        },
        parseFloatFromCurrency(value) {
            if (value === null || value === undefined || value === '') {
                return 0;
            }

            if (typeof value === 'string') {
                const stringWithoutCommas = value.replace(/,/g, '');
                return parseFloat(stringWithoutCommas);
            }

            return value;
        },
        calculateDiff() {
            this.actual_balance_and_expected_balance_diff = this.total_actual_balance - this.parseFloatFromCurrency(this.total_expected_balance);
            this.expected_balance_is_higher_than_actual = this.actual_balance_and_expected_balance_diff < 0;
        },
    },
    mounted() {
        this.checkSettlementToken();
        this.getAllBalances();
    },
    updated() {
        this.calculateDiff();
    },
}
</script>
